import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createSurveyAction = createAsyncThunk(
    'create-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/add-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createSurveySlice = createSlice({
    name: 'create-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createSurveyReducer = createSurveySlice.reducer    